import React, { useContext, useState, useRef, useEffect } from "react";
import { Container, Nav, Navbar, NavDropdown, Form } from "react-bootstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from '../AuthContext';
import "./TopNavbar.css";

const TopNavbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logoutUser, unansweredCount } = useContext(AuthContext);
  const [isSearchExpanded, setIsSearchExpanded] = useState(false);
  const searchInputRef = useRef(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [selectedSuggestionIndex, setSelectedSuggestionIndex] = useState(-1);
  const [expanded, setExpanded] = useState(false);

  // --- NOVO: Stanje za sledenje drsanju ---
  const [showMobileSearch, setShowMobileSearch] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      const params = new URLSearchParams();
      params.set("title", searchQuery.trim());
      navigate(`/oglasi?${params.toString()}`);
      setIsSearchExpanded(false);
      setExpanded(false);
      setSuggestions([]);
    }
  };

  useEffect(() => {
    if (searchQuery.trim() === "") {
      setSuggestions([]);
      return;
    }
    const fetchSuggestions = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/listings/suggestions?query=${encodeURIComponent(searchQuery)}`);
        if (response.ok) {
          const data = await response.json();
          setSuggestions(data);
        }
      } catch (error) {
        console.error("Error fetching suggestions:", error);
      }
    };
    fetchSuggestions();
  }, [searchQuery]);

  // --- NOVO: useEffect za sledenje dogodku drsanja ---
  useEffect(() => {
    const controlMobileSearchVisibility = () => {
      // Ta funkcionalnost naj deluje samo na mobilnih napravah (širina pod 992px)
      if (typeof window !== 'undefined' && window.innerWidth < 992) {
        if (window.scrollY > lastScrollY && window.scrollY > 150) { // Uporabnik drsa navzdol
          setShowMobileSearch(false);
        } else { // Uporabnik drsa navzgor
          setShowMobileSearch(true);
        }
        setLastScrollY(window.scrollY);
      }
    };

    window.addEventListener('scroll', controlMobileSearchVisibility);

    // Počistimo listener, ko se komponenta uniči
    return () => {
      window.removeEventListener('scroll', controlMobileSearchVisibility);
    };
  }, [lastScrollY]);


  const handleKeyDown = (e) => {
    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        setSelectedSuggestionIndex(prev => prev < suggestions.length - 1 ? prev + 1 : prev);
        break;
      case 'ArrowUp':
        e.preventDefault();
        setSelectedSuggestionIndex(prev => (prev > 0 ? prev - 1 : -1));
        break;
      case 'Enter':
        e.preventDefault();
        if (selectedSuggestionIndex >= 0 && suggestions[selectedSuggestionIndex]) {
          const selected = suggestions[selectedSuggestionIndex];
          setSearchQuery(selected);
          setSuggestions([]);
          navigate(`/oglasi?title=${encodeURIComponent(selected)}`);
          setIsSearchExpanded(false);
        } else {
          handleSearch(e);
        }
        break;
      case 'Escape':
        setSuggestions([]);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (isSearchExpanded && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [isSearchExpanded]);

  const handleLogout = async () => {
    await logoutUser();
    navigate("/prijava");
  };

  const menuData = [
    { path: "/", name: "Domov" },
    { path: "/kategorije", name: "Kategorije" },
    { path: "/oglasi", name: "Vsi oglasi" }
  ];

  return (
    <>
      <Navbar expanded={expanded} onToggle={(isOpen) => setExpanded(isOpen)} className={`navbar ${isSearchExpanded ? 'expanded' : ''}`} expand="lg" sticky="top">
        <Container>
          <Navbar.Brand href="/" className="brand">
            <img src="/LOGO 2 TEXT RIGHT.svg" alt="Logo" />
          </Navbar.Brand>
          <div className="d-flex align-items-center">
            <NavDropdown
              title={
                <div className="list_item position-relative">
                  <i className="fa-solid fa-user"></i>
                  {unansweredCount > 0 && (
                    <span className="badge bg-danger position-absolute top-0 start-100 translate-middle">
                      {unansweredCount}
                    </span>
                  )}
                </div>
              }
              id="navbarDropdown"
              className="navbarDropdown"
            >
              {user ? (
                <>
                  {user.role === 'admin' && (
                    <>
                      <NavDropdown.Item onClick={() => navigate("/admin/dashboard")} className="custom-dropdown-item text-danger fw-bold">
                        <i className="fa-solid fa-user-shield me-2"></i> Admin plošča
                      </NavDropdown.Item>
                      <NavDropdown.Divider />
                    </>
                  )}
                  <NavDropdown.Item onClick={() => navigate("/moj-racun/nadzorna-plosca")} className="custom-dropdown-item">
                    <i className="fa-solid fa-gauge-high me-2"></i> Nadzorna plošča
                  </NavDropdown.Item>
                  <NavDropdown.Item onClick={() => navigate("/moj-racun/priljubljeni-oglasi")} className="custom-dropdown-item">
                    <i className="fa-solid fa-heart me-2"></i> Priljubljeni oglasi
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/moj-racun/neodgovorjena-vprasanja" className="custom-dropdown-item position-relative">
                    <i className="fa-solid fa-envelope me-2"></i> Neodgovorjena vprašanja
                    {unansweredCount > 0 && <span className="pulse-dot"></span>}
                  </NavDropdown.Item>
                  <NavDropdown.Item onClick={() => navigate("/moj-racun/nastavitve-profila")} className="custom-dropdown-item">
                    <i className="fa-solid fa-user-cog me-2"></i> Nastavitve profila
                  </NavDropdown.Item>
                  <NavDropdown.Item onClick={() => navigate("/moj-racun/faq")} className="custom-dropdown-item">
                    <i className="fa-solid fa-circle-question me-2"></i> Pogosta vprašanja
                  </NavDropdown.Item>
                  <NavDropdown.Item onClick={handleLogout} className="custom-dropdown-item">
                    <i className="fa-solid fa-right-from-bracket me-2"></i> Odjava
                  </NavDropdown.Item>
                </>
              ) : (
                <NavDropdown.Item href="/prijava" className="custom-dropdown-item">
                  Prijava
                </NavDropdown.Item>
              )}
            </NavDropdown>
            <Navbar.Toggle aria-controls="navbar-collapse" />
          </div>

          <Navbar.Collapse id="navbar-collapse" className={isSearchExpanded ? 'w-100' : ''}>
            {isSearchExpanded ? (
              <Form className={`nav_search d-flex ${isSearchExpanded ? 'expanded' : ''}`} onClick={(e) => e.stopPropagation()} onSubmit={handleSearch}>
                <Form.Control
                  ref={searchInputRef}
                  type="search"
                  placeholder="Išči oglase"
                  className="nav_search-input"
                  aria-label="Search"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onKeyDown={handleKeyDown}
                />
                <button className="btn btn-success nav_search_btn">
                  <i className="fa-solid fa-magnifying-glass"></i>
                </button>
                {suggestions.length > 0 && (
                  <div className="suggestions-list">
                    {suggestions.map((suggestion, index) => (
                      <div
                        key={suggestion}
                        className={`suggestion-item ${index === selectedSuggestionIndex ? 'selected' : ''}`}
                        onClick={() => {
                          setSearchQuery(suggestion);
                          setSuggestions([]);
                          navigate(`/oglasi?title=${encodeURIComponent(suggestion)}`);
                        }}
                        onMouseEnter={() => setSelectedSuggestionIndex(index)}
                      >
                        {suggestion}
                      </div>
                    ))}
                  </div>
                )}
              </Form>
            ) : (
              <>
                <Nav className="ms-auto">
                  {menuData.map((item) => {
                    const isActive = location.pathname === item.path;
                    return (
                      <Link to={item.path} key={item.name} className={`nav-link ${isActive ? 'active' : ''}`} onClick={() => setExpanded(false)}>
                        <div className={`list_item ${isActive ? 'active' : ''}`}>{item.name}</div>
                      </Link>
                    );
                  })}
                </Nav>
                <Form className={`nav_search d-none d-lg-flex ${isSearchExpanded ? 'expanded' : ''}`} onClick={() => setIsSearchExpanded(true)}>
                  <Form.Control type="search" placeholder="Išči oglase" className="nav_search-input" aria-label="Search" readOnly />
                  <button className="btn btn-success nav_search_btn">
                    <i className="fa-solid fa-magnifying-glass"></i>
                  </button>
                </Form>
                <Nav className="ms-auto">
                  <button className="btn btn-success post-item-navbar-btn" onClick={() => navigate("/objavi-oglas")}>Objavi oglas</button>
                </Nav>
              </>
            )}
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* --- SPREMENJENO: Ločena iskalna vrstica samo za mobilne naprave --- */}
      <div className={`mobile-search-wrapper d-lg-none ${showMobileSearch ? 'visible' : 'hidden'}`}>
        <Container>
          <Form className="nav_search_mobile d-flex position-relative py-2" onSubmit={handleSearch}>
            <Form.Control
              type="search"
              placeholder="Išči oglase"
              // POPRAVEK: Dodan razred flex-grow-1 za polno širino
              className="nav_search-input flex-grow-1"
              aria-label="Search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onKeyDown={handleKeyDown}
            />
            <button type="submit" className="btn btn-success nav_search_btn">
              <i className="fa-solid fa-magnifying-glass"></i>
            </button>
            {suggestions.length > 0 && (
              <div className="suggestions-list">
                {suggestions.map((suggestion, index) => (
                  <div
                    key={suggestion}
                    className={`suggestion-item ${index === selectedSuggestionIndex ? 'selected' : ''}`}
                    onClick={() => {
                      setSearchQuery(suggestion);
                      setSuggestions([]);
                      navigate(`/oglasi?title=${encodeURIComponent(suggestion)}`);
                    }}
                    onMouseEnter={() => setSelectedSuggestionIndex(index)}
                  >
                    {suggestion}
                  </div>
                ))}
              </div>
            )}
          </Form>
        </Container>
      </div>

      {isSearchExpanded && (
        <div className="search-overlay" onClick={() => setIsSearchExpanded(false)} />
      )}
    </>
  );
};

export default TopNavbar;